;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { SparklesIcon } from '@heroicons/react/24/solid'
import { pluralize } from '@qogita/format/string'
import { Anchor } from '@qogita/ui/v2/anchor'
import { Badge } from '@qogita/ui/v2/badge'
import { Icon } from '@qogita/ui/v2/icon'
import clsx from 'clsx'
import { Suspense } from 'react'
import { OrderExpiryTimeBadge } from 'src/components/order-expiry-time-badge'
import { ErrorBoundary } from 'src/deprecated/components/shared/ErrorBoundary'
import { getFormattedCurrencyWithSymbol } from 'src/deprecated/utils/getFormattedCurrency'
import { trackDashboardNewOrderClicked } from 'src/deprecated/utils/report/tracking'
import { routes } from 'src/deprecated/utils/routes'

import { useExpiringAndUnreadOrders } from '../hooks/useExpiringAndUnreadOrders'

type Props = { className?: string }

function NewOrdersInner() {
  const {
    unread: { sales, totalResults },
  } = useExpiringAndUnreadOrders()

  return (
    <div className={clsx({ 'pb-6': sales.length > 0 })}>
      <div
        className={clsx('flex flex-row items-center p-6', {
          'pb-3': sales.length > 0,
        })}
      >
        <Icon
          name="heroicons/outline/sparkles"
          // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
          className="mr-3 size-6 text-gray-900"
        />
        <h3 className="typography-header-lg-bold flex items-center leading-7">
          {pluralize({ word: 'new order', count: totalResults })}
        </h3>
      </div>

      {sales.length > 0 ? (
        <div className="max-h-60 overflow-y-auto px-6">
          <table className="w-full">
            <thead className="sr-only">
              <tr>
                <th>Order number</th>
              </tr>

              <tr>
                <th>Total price</th>
              </tr>

              <tr>
                <th>Expiry in hours</th>
              </tr>
            </thead>

            <tbody>
              {sales.map((order) => {
                const formattedTotal = getFormattedCurrencyWithSymbol(
                  +order.total,
                  order.metadata.currency,
                )

                return (
                  <tr key={order.qid} className="h-[48px]">
                    <td className="flex flex-wrap items-center gap-x-2">
                      <Anchor
                        href={routes.order(order.qid)}
                        variant="text"
                        color="primary"
                        // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
                        className="font-normal"
                        onClick={() => {
                          trackDashboardNewOrderClicked(order)
                        }}
                      >
                        {order.order}
                      </Anchor>
                    </td>
                    <td>
                      {order.isEnterprisePackaging ? (
                        <Badge
                          emphasis="high"
                          variant="feature"
                          icon="heroicons/outline/check-badge"
                          help="High priority, Enterprise packaging standards required"
                        >
                          Enterprise
                        </Badge>
                      ) : null}
                    </td>

                    <td className="px-6">
                      <p className="flex justify-end text-gray-700">
                        {formattedTotal}
                      </p>
                    </td>

                    <td className="flex justify-end">
                      <OrderExpiryTimeBadge expiredAt={order.expiredAt} />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  )
}

function Fallback() {
  return (
    <div className="flex flex-row items-center p-6">
      <div className="mr-3 rounded-xs bg-gray-200 motion-safe:animate-pulse">
        <SparklesIcon className="stroke-success-700 invisible h-6 w-6" />
      </div>
      <div className="rounded-xs bg-gray-200 motion-safe:animate-pulse">
        <h3 className="readSales typography-body-base-bold invisible flex items-center">
          {pluralize({ word: 'new order', count: 3 })}
        </h3>
      </div>
    </div>
  )
}
export function NewOrders({ className }: Props) {
  return (
    <ErrorBoundary fallback={null}>
      <article
        className={clsx(
          className,
          'relative rounded-lg border border-gray-200 bg-white shadow-xs',
        )}
      >
        <Suspense fallback={<Fallback />}>
          <NewOrdersInner />
        </Suspense>
      </article>
    </ErrorBoundary>
  )
}
